export default {
    EM_ELABORACAO: 'Em elaboração',
    ATIVO: 'Ativo',
    BAIXADO: 'Baixado'
}
